import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { DataService } from '../data.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AnonymousGuard implements CanActivate {

  constructor(private dataService: DataService, private router: Router) {

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      // TODO: make this look at a 'true' login mechanism, not just checkign for the info. this is TEMP
        let token = window.localStorage.getItem('user_token');
        let valid = window.localStorage.getItem('user_token_valid_until');
        let token_is_valid = false;

        if (!!token && !!valid){
          let now = new Date();
          let valid_date = new Date(valid);
          token_is_valid = valid_date > now;
        }

        if (token_is_valid){
          this.dataService.loadUserDetails(); // load up info, if available
          // this.ngOnChanges();
          this.dataService.is_logged_in = true;
          // console.log('should NOT login, already logged in');
          this.router.navigate(['/shop']);
          return false;
        }
        else {
          // let refresh_token = window.localStorage.getItem('user_refresh_token');
          // if( !!refresh_token ){
          //     let tt = atob(refresh_token).split('::');
          //     if (!!tt && tt.length === 2) {
          //       this.dataService.login(tt[0], tt[1]);
          //     }
          //     else {
          //
          //       this.dataService.is_logged_in = false;
          //       console.log('should login, autorefresh failed');
          //       this.router.navigate(['/login']);
          //       return false
          //     }
          // }
          // else {
          //   // no refresh token..
          //   console.log('should login, no refresh token');
          //   this.router.navigate(['/login']);
          //   return false
          // }
          return true
        }


  }
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/guards/anonymous.guard.ts